import React from 'react';
import {cn} from '@utils';

export interface BaseItem {
  key: string;
  label: string;
}

const activeCls = 'rounded-full bg-gradient-to-t from-[#8700DA] to-[#7000FF]';
const baseTab = 'flex-1 h-full text-white flex items-center justify-center';

export interface TabsProps<T extends BaseItem> {
  /**
   * Tab项列表数据
   */
  items: T[];
  /**
   * 当前激活的tab key
   */
  activeKey?: string;
  /**
   * 点击tab时的回调
   */
  onChange?: (activeKey: string, item: T) => void;
  /**
   * 自定义渲染Tab项
   */
  renderItem?: (item: T, isActive: boolean) => React.ReactNode;
}

export default function Tabs<T extends BaseItem>({
  items = [],
  activeKey,
  onChange,
  renderItem,
}: TabsProps<T>) {
  // 如果没有指定activeKey，默认选中第一个tab
  const activeTabKey = activeKey || (items[0]?.key ?? '');

  const handleTabClick = (item: T) => {
    onChange?.(item.key, item);
  };

  return (
    <div className="border bg-[#00000066] relative flex border-[rgba(255,255,255,0.49)] rounded-full w-60 h-6 text-center items-center text-white">
      {items.map(item => {
        const isActive = item.key === activeTabKey;
        return (
          <div
            key={item.key}
            className={cn(baseTab, isActive && activeCls)}
            onClick={() => handleTabClick(item)}>
            {renderItem ? renderItem(item, isActive) : item.label}
          </div>
        );
      })}
    </div>
  );
}
